import { useDropzone } from 'react-dropzone';
import { Upload, File } from 'lucide-react';
import { useState } from 'react';
import { uploadFile } from '../../lib/supabase';
import toast from 'react-hot-toast';

export const FileUpload = ({ folder = 'docs', onUploaded, label = 'Drop file here or click to upload' }) => {
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(null);

  const onDrop = async (files) => {
    const file = files[0];
    if (!file) return;
    setUploading(true);
    try {
      const result = await uploadFile(file, folder);
      setUploaded(file.name);
      onUploaded?.(result);
      toast.success('File uploaded!');
    } catch (e) {
      toast.error('Upload failed: ' + e.message);
    }
    setUploading(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false });

  return (
    <div {...getRootProps()} className={`dropzone${isDragActive ? ' active' : ''}`}>
      <input {...getInputProps()} />
      {uploaded ? (
        <><File style={{ width: 28, height: 28, margin: '0 auto 8px', color: 'var(--green)' }} /><p style={{ color: 'var(--green)' }}>{uploaded}</p></>
      ) : uploading ? (
        <><div className="spinner" style={{ margin: '0 auto 8px' }} /><p>Uploading...</p></>
      ) : (
        <><Upload /><p>{label}</p><p style={{ fontSize: 11, marginTop: 4 }}>PDF, JPG, PNG supported</p></>
      )}
    </div>
  );
};
